import React from "react"
import { AppRegistry } from "react-native"
import { BrowserRouter } from "react-router-dom"

import { browserTracingIntegration } from "@sentry/react"
import type { ReactNativeOptions } from "@sentry/react-native"
import smoothscroll from "smoothscroll-polyfill"

import appJson from "./app.json"
import App from "./src/app"
import "./src/assets/fonts/fonts.css"
import { initializeLogging } from "./src/lib/logging-initialize"
import { registerServiceWorker } from "./src/lib/service-worker-registration.web"
import { initializeSignoz } from "./src/lib/signoz"

function Root() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  )
}

const appName = appJson.expo.name

smoothscroll.polyfill()

initializeSignoz()

initializeLogging({
  integrations: [browserTracingIntegration()],
} as unknown as ReactNativeOptions)

registerServiceWorker()

AppRegistry.registerComponent(appName, () => Root)

AppRegistry.runApplication(appName, {
  rootTag: document.getElementById("root"),
})
